// extracted by mini-css-extract-plugin
export default {"container":"k2-z"};